import { Chip } from "@heroui/react";
import { Users } from "lucide-react";
import React from "react";

const RoleBagde = ({ role }) => {
  return (
    <Chip variant="soft" className="bg-tertiary/15 account-tier-badge">
      <Chip.Label className="flex gap-2 items-center flex-row text-tertiary">
        <Users size={12} className="fill-tertiary text-tertiary" /> {role}
      </Chip.Label>
    </Chip>
  );
};

export default RoleBagde;
